



import { getAuthData } from '../../Utils/AuthUtils';
import apiService from '../../Services/APIService';
import { checkAPIResponse } from '../../Utils/APIResponseUtils';
import { format } from 'date-fns';

const authData = getAuthData();
const currentUserID = authData?.UserID ? String(authData.UserID) : "";

export const getContractAPI = async ({ ctrcTypeID, typeID, prdType, prdQty, year, month }) => {
  try {
    const payload = [{
      typeID,
      ctrcTypeID,
      prdType,
      prdQty,
      year,
      month
    }];
    const result = await apiService.getData(9, 'get', payload);
    checkAPIResponse(result);

    // Parse the updatePackage to get the actual data
    const updatePackage = JSON.parse(result.updatePackage);
    const data = updatePackage.Table1;

    return data
  } catch (error) {
    console.error('getConnectionDetail API error:', error);
    throw error;
  }
};



export const manageContractAPI = async (contractData, operation = 'ADD') => {
  try {
    const isDelete = operation === 'DELETE';
    const isRenew = operation === 'RENEW';
    const isCancel = operation === 'CANCEL';
    const d = contractData;

    if (isRenew) {
      const renewData = {
        oldContractID: d.contractID || 0,
        newStartDate: d.startDate || '',
        newEndDate: d.expireDate || '',
        newFile: d.contractFile || ''
      };
      const result = await apiService.sendChange(9, 'renew', renewData);
      checkAPIResponse(result);
      return result;
    }

    if (isCancel) {
      const cancelData = {
        contractID: d.contractID || 0,
        sellerAgencyID: d.sellerAgencyID || 0,
        buyerAgencyID: d.buyerAgencyID || 0,
        cancelledDT: d.cancelDate || '',
        cancellationReason: d.cancellationReason || ''
      };
      const result = await apiService.sendChange(9, 'cancel', cancelData);
      checkAPIResponse(result);
      return result;
    }

    const isSeller = d.isSeller;

    // Prepare follow-ups with complete task data
    let followUpsJSON = '[]';
    if (d.followUps && Array.isArray(d.followUps) && d.followUps.length > 0) {
      const expiryDate = new Date(d.expireDate);

      followUpsJSON = JSON.stringify(d.followUps.map(f => {
        let taskDate = null;
        let taskTitle = '';

        if (f.dateType === 'before') {
          const days = parseInt(f.days) || 0;
          const followUpDate = new Date(expiryDate);
          followUpDate.setDate(followUpDate.getDate() - days);
          taskDate = format(followUpDate, 'yyyy-MM-dd');
          taskTitle = `Contract expiry after ${days} day${days === 1 ? '' : 's'}`;
        } else if (f.dateType === 'on' && f.tskDueDT) {
          taskDate = format(new Date(f.tskDueDT), 'yyyy-MM-dd');
          taskTitle = `Follow-up Contract Expiry`;
        }

        return {
          Typ: f.taskType || '',
          DT: taskDate,
          Notes: taskTitle
        };
      }).filter(f => f.DT && f.Notes)); 
    }

    const preparedContractData = {
      changeType: isDelete ? 'DEL' : operation,
      contractID: d.contractID || 0,
      connID: d.connID || 0,
      contractNo: d.contractNo || '',
      contractType: d.contractType || '',
      contractTypeID: d.contractTypeID || 0,
      product: d.product || '',
      startDate: d.startDate || '',
      expiryDate: d.expireDate || '',
      charges: parseFloat(d.charges || 0),
      renewalCharges: parseFloat(d.renewal || 0),
      currencyID: d.currencyID || 1,
      contractFile: d.contractFile || '',
      connContactName: d.connContactName || '',
      connContactID: d.connContactID || 0,
      connCC: d.connCC || 91,
      connMobile: d.connMobile || '',
      connEmail: d.connEmail || '',
      notes: d.notes || '',
      isSeller: isSeller,
      followUps: followUpsJSON
    };

    const result = await apiService.sendChange(9, 'set', preparedContractData);
    checkAPIResponse(result);
    return result;
  } catch (error) {
    console.error(`${operation} contract API error:`, error);
    throw error;
  }
};